module.exports = __webpack_public_path__ + "static/media/Image-Article1.1b9a7b79.png";